export default "__VITE_ASSET__JMOewHpC__"